module.exports = __webpack_public_path__ + "img/cover2.f954e870.png";